import React, { useState, useEffect } from 'react';

const OfflineBanner: React.FC = () => {
    const [offline, setOffline] = useState(!navigator.onLine);

    useEffect(() => {
        const goOffline = () => setOffline(true);
        const goOnline = () => setOffline(false);
        window.addEventListener('offline', goOffline);
        window.addEventListener('online', goOnline);
        return () => {
            window.removeEventListener('offline', goOffline);
            window.removeEventListener('online', goOnline);
        };
    }, []);

    if (!offline) return null;

    return (
        <div style={{
            background: '#f59e0b', color: '#000', textAlign: 'center',
            padding: '6px 12px', fontSize: '13px', fontWeight: 600,
            position: 'sticky', top: 0, zIndex: 9999,
        }}>
            ⚠️ Sin conexión a internet — los cambios se sincronizarán al reconectar
        </div>
    );
};

export default OfflineBanner;
